//获取作业章节列表（判断有无作业）
API.reqHomeworkChapterList = data => ajax.get('/learn/v1/teaching/course/get/chapter/contents', data)
